import { BeketTransportType } from 'shared/constants'

import { ChildAvailable } from './components/child-available'
import { ChildNotAvailable } from './components/child-not-available'

interface Props {
  transportType?: string
}

export const FormInfo = ({ transportType }: Props) => {
  if (transportType === BeketTransportType.VAN.key) {
    return <ChildNotAvailable />
  }

  return <ChildAvailable />
}
